export {type Cstr, type Constructible, isClass} from "./classes";
export {type Mutable, mutable} from "./mutable";

export {NO_VALUE, NULL_OP, NULL_OBJ, NULL_ARRAY, FCT_NULL, FCT_FALSE, FCT_TRUE} from "./NullObjects";